import styled from "styled-components";
export const ProgressContainer = styled.div.withConfig({
  displayName: "progressstyles__ProgressContainer",
  componentId: "sc-g52lnd-0"
})(["", ""], {
  width: "100%"
});
